module.exports = "https://www.gc-pro.gnp.com.mx/841421a399190a7c65e9bfc4cc089b54.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-delete.png
// module id = 1825
// module chunks = 0